export default __webpack_public_path__ + "static/matriculas-1e762e97970c54eeff799ced0a12f33f.png";